import React, { Component, Fragment } from "react";
import {
  Card,
  Button,
  Icon,
  Popup,
  Modal,
  Form,
  Checkbox,
} from "semantic-ui-react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  saveTeams,
  openModalCreateTeam,
  openModalCreateUser,
  openModalAddUser,
  openModalManageTeam,
} from "../../store/actions/AdministrationActions";

import Can, { Permission } from "../../containers/Permission";
import client from "../../store/apolloClient";
import gql from "graphql-tag";
import PositiveMessage from "../components/PositiveMessage";

class RootComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: -1,
      newName: "",
      status: null,
      hiddenMessage: true,
    };
  }

  createUserInTeam(team_id) {
    this.props.openModalCreateUser(team_id);
  }
  addUserToTeam(team_id) {
    this.props.openModalAddUser(team_id);
  }
  manageTeam(team_id) {
    this.props.openModalManageTeam(team_id);
  }
  createNewTeam() {
    this.props.openModalCreateTeam();
  }

  updateTeam() {
    let set = "";
    if (this.state.status !== null) {
      set = `status: ${this.state.status === true ? 0 : 1}`;
    }
    if (this.state.newName !== "") {
      if (set === "") {
        set += `name: "${this.state.newName.trim()}"`;
      } else {
        set += `, name: "${this.state.newName.trim()}"`;
      }
    }

    if (set !== "") {
      const mutation = gql`
      mutation updateTeam {
        update_simcaa_t_team(where: {id: {_eq: ${this.state.open}}}, _set: {${set}}) {
          affected_rows
        }
      }
      `;

      client.mutate({ mutation }).then((data) => {
        if (data.data.update_simcaa_t_team) {
          this.setState({ hiddenMessage: false });
          this.props.getTeams();
        }
      });
    }
  }

  render() {
    const { t } = this.props;

    //aggiungo card di questo team

    let teamsLayout = this.props.teams.filter((team, idx) => team.weight > 70);

    teamsLayout = teamsLayout.map((element, idx) => {
      let checked =
        this.state.status !== null ? this.state.status : element.status;
      if (Number.isInteger(checked)) {
        checked = checked === 1 ? false : true;
      }

      return (
        <Fragment key={idx}>
          <Card id={idx}>
            <Card.Content>
              <Card.Header>{element.team_name}</Card.Header>
              <Card.Meta>{element.team_email}</Card.Meta>
              <Card.Description>
                {Permission(true, element.permissions.can_manage_team) ? (
                  <Icon
                    name="edit"
                    circular
                    size="large"
                    className="icon-pointer"
                    onClick={() =>
                      this.setState({
                        open: element.id,
                        newName: "",
                        hiddenMessage: true,
                        status: null,
                      })
                    }
                  />
                ) : null}
                {"Descrizione del team"}
              </Card.Description>
            </Card.Content>
            <Card.Content extra>
              <div className="ui three buttons">
                {Permission(true, element.permissions.can_manage_user) ? (
                  <Fragment>
                    <Button
                      basic
                      color="violet"
                      onClick={() => this.createUserInTeam(element.team_id)}
                    >
                      Crea nuovo utente
                    </Button>
                    <Button
                      basic
                      color="blue"
                      onClick={() => this.addUserToTeam(element.team_id)}
                    >
                      Aggiungi utente
                    </Button>
                    <Button
                      basic
                      color="green"
                      onClick={() => this.manageTeam(element.team_id)}
                    >
                      Gestisci
                    </Button>
                  </Fragment>
                ) : null}
              </div>
            </Card.Content>
          </Card>
          <Modal open={this.state.open === element.id}>
            <Modal.Header>Select a Photo</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                <Form>
                  <Form.Input
                    width={8}
                    label="Nome del Team"
                    value={
                      this.state.newName
                        ? this.state.newName
                        : element.team_name
                    }
                    onChange={(e) => this.setState({ newName: e.target.value })}
                  />
                  <Form.Field
                    control={Checkbox}
                    label="Team bloccato"
                    toggle
                    checked={checked}
                    onChange={() => this.setState({ status: !checked })}
                  />
                </Form>
                <PositiveMessage
                  message="Team aggiornato con successo"
                  hidden={this.state.hiddenMessage}
                />
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button positive onClick={this.updateTeam.bind(this)}>
                Conferma
              </Button>
              <Button
                negative
                onClick={() =>
                  this.setState({ open: -1, newName: "", status: null })
                }
              >
                Close
              </Button>
            </Modal.Actions>
          </Modal>
        </Fragment>
      );
    });
    let cardWidth = 0;
    if (document.getElementById("0") !== null) {
      cardWidth = document.getElementById("0").offsetWidth / 2;
    }
    //let cardWidth = document.getElementById('0').offsetWidth
    return (
      <Fragment>
        <Card.Group centered style={{ margin: "10px" }}>
          {teamsLayout}
          <Can perform="can_create_team">
            <Popup
              trigger={
                <Button
                  circular
                  icon={<Icon name="plus" size="big" />}
                  style={{
                    width: cardWidth + "px",
                    height: cardWidth + "px",
                    margin: "auto 20px",
                    // marginTop: cardWidth / 3 + "px",
                    // marginLeft: cardWidth / 4 + "px"
                  }}
                  onClick={() => this.props.openModalCreateTeam()}
                />
              }
              content="Crea un nuovo team"
            />
          </Can>
        </Card.Group>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
    teams: state.adminReducer.teams,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    openModalCreateUser: (team_id) => dispatch(openModalCreateUser(team_id)),
    openModalAddUser: (team_id) => dispatch(openModalAddUser(team_id)),
    openModalManageTeam: (team_id) => dispatch(openModalManageTeam(team_id)),
    openModalCreateTeam: () => dispatch(openModalCreateTeam()),
    getTeams: () => dispatch(saveTeams()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(RootComponent));



// WEBPACK FOOTER //
// ./src/administration/containers/RootComponent.js